export default "/images/vendor/flag-icon-css/flags/4x3/tf.svg?cf4959c4339d5b1230931b8b44c5e9a9";